import {
  DEFAULT_OBJECT_FLAG_BY_ENTITY_COMMAND_TYPE,
  ENTITY_COMMAND_TYPE,
  TYPES_SOURCE_OPTIONS,
} from '@constants'
import { CommandParameterDTO, EntityCommandDTO } from '@types'

type ObjectModelCommand = { code?: string; name?: string; flags?: string[]; httpMethod: string }

type SelectCommandForEntityActionParams = {
  overrideCommands?: EntityCommandDTO[] | undefined
  objectCommands: ObjectModelCommand[] | undefined
  actionType: ENTITY_COMMAND_TYPE
}

type SelectedEntityCommand = {
  isOverridden: boolean
  httpMethod: string
  commandCode: string
  resource?: TYPES_SOURCE_OPTIONS
  objectCode?: string
  parameters?: CommandParameterDTO[]
  body?: CommandParameterDTO[]
  expands?: string[]
} | null

export const selectCommandForEntityAction = ({
  overrideCommands,
  objectCommands,
  actionType,
}: SelectCommandForEntityActionParams): SelectedEntityCommand => {
  const overriddenCommand = (overrideCommands ?? []).find(command => command.type === actionType)

  if (overriddenCommand) {
    return {
      isOverridden: true,
      httpMethod: overriddenCommand.httpMethod,
      commandCode: overriddenCommand.name,
      resource: overriddenCommand.resource,
      objectCode: overriddenCommand.objectCode,
      parameters: overriddenCommand.parameters,
      body: overriddenCommand.body,
      expands: overriddenCommand.expands,
    }
  }

  const defaultFlag = DEFAULT_OBJECT_FLAG_BY_ENTITY_COMMAND_TYPE[actionType]

  if (!defaultFlag) {
    return null
  }

  const defaultObjectCommand = (objectCommands ?? []).find(command =>
    (command.flags ?? []).includes(defaultFlag)
  )

  if (!defaultObjectCommand) {
    return null
  }

  const commandCode = defaultObjectCommand.code ?? defaultObjectCommand.name
  if (!commandCode) {
    return null
  }

  return {
    isOverridden: false,
    httpMethod: defaultObjectCommand.httpMethod,
    commandCode,
  }
}
